module.exports = __webpack_public_path__ + "img/download.c59c7746.svg";